
import { defineComponent, PropType } from 'vue';
import { ITopic } from '@/models/topic.model';

export default defineComponent({
  inheritAttrs: false,
  name: 'TopicList',
  components: {},
  props: {
    topics: {
      type: Array as PropType<Array<ITopic>>,
      required: true,
      default: () => [],
    },
  },
  emits: ['toggleTopic'],
  setup(props, context) {
    function toggleTopic(topic: ITopic, index: number) {
      context.emit('toggleTopic', topic, index);
    }
    return {
      toggleTopic,
    };
  },
});
